import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserSessionService } from './user-session.service';
import { DestroyRxComponent } from '../../components/destroy-rx/destroy-rx.component';
import { takeUntil } from 'rxjs/operators';
import { AppConfigService } from '../../app.config';

/**
 * Adds the required `tenant` and `session` headers to all http requests.
 */
@Injectable()
export class HeaderInterceptorService
    extends DestroyRxComponent
    implements HttpInterceptor
{
    tenant: string;
    session!: string;
    defaultSession: string;

    /**
     * Constructs the pipeline to update the session on session change and sets the tenant and default session.
     * @param userSession Service providing the session$ observable.
     * @param appConfigs Service providing the app configs.
     */
    constructor(userSession: UserSessionService, appConfigs: AppConfigService) {
        super();
        userSession.session$
            .pipe(takeUntil(this.destroy$))
            .subscribe((session) => (this.session = session.name));
        const config = appConfigs.getConfig();
        this.tenant = config.tenant;
        this.defaultSession = config.defaultSession;
    }

    /**
     * Intercepts all http requests and sets the tenant and session header values required by the api.
     * @param req The current request.
     * @param next The next middleware component.
     */
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler,
    ): Observable<HttpEvent<any>> {
        // TODO: Evaluate this method; it may be better to have a service/local storage approach.
        const modified = req.clone({
            setHeaders: {
                tenant: this.tenant,
                session: this.session ?? this.defaultSession,
            },
        });
        return next.handle(modified);
    }
}
